import React from 'react';

import Permissions from '../auth/Permissions';

export default {};

function HoverHelp({ text }) {
  return (
    <div style={{ width: 300, textOverflow: 'wrap', whiteSpace: 'pre-line' }}>
      {text}
      <br />
      <br />
      For more details on any reports, check out the resources in our ‘Support’ section.
    </div>
  );
}

export const getReports = (t, paidFlags) => {
  const reports = [{
    key: 'employee_payroll',
    title: 'Employee Payroll',
    helpText: (
      <HoverHelp
        text={'A report mainly used by admin staff who are responsible for payroll. It summarizes all staff\'s time sheets and is used to export into excel form for entry into the payroll software (e.g. QuickBooks).'}
      />
    ),
  }, {
    key: 'staff_timesheets',
    title: 'Staff Timesheets',
    helpText: (
      <HoverHelp
        text="This report is typically used by managers and supervisors to review and approve workers hours and ensure they are allocating them to the correct phase and cost codes."
      />
    ),
  }, {
    key: 'service_jobs',
    title: 'Service Jobs',
    helpText: (
      <HoverHelp
        text="This report is shows hours worked on service jobs."
      />
    ),
  }, {
    key: 'project_status',
    title: `${t('Project')} Status`,
    helpText: (
      <HoverHelp
        text={`A detailed report which allows managers to gain insight into ${t('Project').toLowerCase()} hours tracking, primarily allowing managers to have oversight hours worked on each ${t('Project').toLowerCase()}. \n\nNote: only cost codes that are time trackable are included in this report.`}
      />
    ),
  }, {
    key: 'timeline',
    title: `${t('Project')} Timeline`,
    hideDate: true,
    helpText: (
      <HoverHelp
        text={`A powerful report used to foresee gaps in scheduled labour and is typically used to aid in estimating strategies. Users can view an overall timeline of the start/end dates of all company ${t('Project', { count: 0 }).toLowerCase()} or a detailed ${t('Project').toLowerCase()} view which shows scheduled labour by phases and cost codes.`}
      />
    ),
  }, {
    key: 'user_certifications',
    title: 'User Certifications',
    hasPermissions: (positions) => (
      positions?.some(({ name: positionName } = {}) => {
        const formattedName = Permissions.formatPosition(positionName);
        return Permissions.has(`USERS_VIEW_${formattedName}`)
          && (
            Permissions.has(`USERS_${formattedName}`)
            || Permissions.has(`MANAGE_USER_CERTIFICATIONS_${formattedName}`)
            || Permissions.has(`ADD_CERTIFICATIONS_USER_${formattedName}`)
          );
      })
    ),
    hideDate: true,
    hideSearch: false,
    hideSave: true,
    helpText: (
      <HoverHelp
        text="A report which allows managers to view all users and their certifications. This report is used to ensure that all users are up to date with their certifications and that they are not expired."
      />
    ),
  }, {
    key: 'vendor_certifications',
    title: 'Vendor Certifications',
    hasPermissions: () => Permissions.has('VENDORS_READ'),
    hideDate: true,
    hideSearch: false,
    hideSave: true,
    helpText: (
      <HoverHelp
        text="A report which allows managers to view all vendors and their certifications. This report is used to ensure that all vendors are up to date with their certifications and that they are not expired."
      />
    ),
  }, {
    key: 'equipment_certifications',
    title: 'Equipment Certifications',
    hasPermissions: () => Permissions.has('EQUIPMENT_READ'),
    hideDate: true,
    hideSearch: false,
    hideSave: true,
    helpText: (
      <HoverHelp
        text="A report which allows managers to view all equipment and their certifications. This report is used to ensure that all equipment is up to date with their certifications and that they are not expired."
      />
    ),
  }, {
    key: 'cost_code_billing',
    title: 'Cost Code Billing',
    hideDate: false,
    hideSearch: false,
    hideSave: true,
    helpText: (
      <HoverHelp
        text="A report which allows managers to view all cost codes and their current costs/billing rates."
      />
    ),
  }, {
    key: 'wip_summary',
    title: 'WIP Summary',
    hideDate: true,
    hideSave: true,
    helpText: (
      <HoverHelp
        text="A WIP (Work in Progress) summary report provides a financial overview of ongoing projects, tracking costs, revenue, and progress."
      />
    ),
  }];

  if (paidFlags?.includes('AB_WORK_REPORTING')) {
    reports.push({
      key: 'ab_work_reporting',
      title: 'Work Reports',
      helpText: (
        <HoverHelp
          text="A report which allows managers to view and batch work report entries."
        />
      ),
      ignorePermissions: true,
      hideHeader: true,
    });
  }

  return reports;
}
